<template>
  <v-container class="auth-events--header pa-0 pt-4" grid-list-md>
    <v-form class="form">
      <v-row dense>
        <v-col sm="2" v-if="$vuetify.breakpoint.mdAndUp" class="fm-in mr-4">
          <p class="caption text-xs-left grey--text text--darken-1">表示数</p>
          <v-btn-toggle class="transparent" v-model="form.limit" @change="emitForm(1)">
            <v-btn :text="form.limit !== '10'" depressed="form.limit === '10'" color="secondary white--text" value="10">10</v-btn>
            <v-btn :text="form.limit !== '50'" depressed="form.limit === '50'" color="secondary white--text" value="50">50</v-btn>
            <v-btn :text="form.limit !== '100'" depressed="form.limit === '100'" color="secondary white--text" value="100">100</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col xs="12" sm="2">
          <v-menu offset-y full-width
            v-model="config.datepicker"
            transition="scale-transition"
            min-width="290px"
            :close-on-content-click="false"
            :nudge-right="40">
            <template v-slot:activator="{ on }">
              <v-text-field readonly
                v-model="printMinDateFormat"
                v-on="on"
                label="日付"
                :append-icon="form.minDate ? 'fal fa-times' : null"
                @click:append="form.minDate = ''"
              />
            </template>
            <v-date-picker
              v-model="form.minDate"
              locale="ja"
              color="amber"
              :day-format="date => new Date(date).getUTCDate()"
              @input="config.datepicker = false"
            />
          </v-menu>
        </v-col>
        <v-col xs="12" sm="2">
          <v-select
            v-model="form.arrange"
            label="留学の種類"
            :items="getArrangeTypeItems"
            @change="search"
          />
        </v-col>
        <v-col xs="12" sm="5">
          <v-text-field
            v-model="form.q"
            label="フリーワード検索"
            append-icon="fal fa-search"
            clear-icon="fal fa-times"
            @click:append="search"
            @keypress.enter.prevent="search"
          />
        </v-col>
      </v-row>
    </v-form>
    <v-divider></v-divider>
    <v-row dense justify="end">
      <v-col md="2" class="pt-4">
        <span class="body-2 text-xs-center">{{ printPageInfo }}</span>
      </v-col>
      <v-col md="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" v-on="on" :disabled="isLoading || !isAccessiblePrev" @click="prev">
              <v-icon small>fal fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>前へ</span>
        </v-tooltip>
      </v-col>
      <v-col md="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" v-on="on" :disabled="isLoading || !isAccessibleNext" @click="next">
              <v-icon small>fal fa-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>次へ</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>
  </v-container>
</template>

<script>
const DEF = {
  LIMIT: '10',
  PAGENUMBER: 1
}
export default {
  name: 'authorEventsToolbars',
  props: [
    'status',
    'authors',
    'arrangers'
  ],
  data () {
    return {
      config: {
        datepicker: false
      },
      form: {
        status: false,
        minDate: new Date().toISOString().substr(0, 10),
        arrange: '',
        q: '',
        limit: DEF.LIMIT,
        page: DEF.PAGENUMBER,
        size: 0
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.search()
    },
    search: function (page) {
      if (this.$props.status && !this.$props.status.loading) {
        this.$nextTick(() => {
          let fm = this.getForm(page)
          this.$emit('emit', {
            action: 'get',
            data: fm
          })
        })
      }
    },
    prev: function () {
      let num = this.form.page
      if (num !== 1) {
        this.$set(this.form, 'page', num - 1)
        this.emitForm()
      }
    },
    next: function () {
      let num = this.form.page
      if (num !== this.form.size) {
        this.$set(this.form, 'page', num + 1)
        this.emitForm()
      }
    },
    count: function (size) {
      this.$set(this.form, 'size', size)
    },
    getForm: function (page) {
      return this.form
    },
    emitForm: function (page) {
      if (page) {
        this.$set(this.form, 'page', page)
      }
      this.$nextTick(() => {
        this.$emit('emit', {
          action: 'page',
          data: this.form
        })
      })
    }
  },
  computed: {
    isLoading () {
      return (this.$props.status && this.$props.status.loading)
    },
    isAccessibleNext () {
      return ((this.form.size - this.form.page * this.form.limit) > 0)
    },
    isAccessiblePrev () {
      return ((this.form.page - 1) > 0)
    },
    getArrangeTypeItems () {
      return [{
          text: '選択なし',
          value: ''
        }, ...Object.keys(this.$mango.arrange.types).map(key => {
        return {
          text: this.$mango.arrange.types[key],
          value: key
        }
      })]
    },
    printMinDateFormat () {
      return this.form.minDate ? `${this.$moment(this.form.minDate).format('YYYY/MM/DD')}〜` : ''
    },
    printFormStatus () {
      return this.form.status ? '出発済み' : '出発前'
    },
    printPageInfo () {
      let limit = parseInt(this.form.limit)
      let num = this.form.page
      let st = limit * (num - 1) + 1
      let ed = Math.min(limit * num, this.form.size)
      return `${st} - ${ed} / ${this.form.size}`
    }
  }
}
</script>

<style lang="scss">
.auth-events--header {
  .form {
    .fm-in {
      position: relative;
      .caption {
        position: absolute;
        top: -1.5em;
      }
    }
  }
}
</style>
